import { Injectable } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../src/environments/environment';
import { EVENTS, EventNames } from '@app/constants/events.constants';
import { fetchAuthSession } from '@aws-amplify/auth';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private readonly httpService: AmplifyHttpClient, private http: HttpClient) {}

  private trackEventworker: Worker;
  private adminSelected = new Subject<any>();
  private shareDone = new Subject<any>();
  private changesInDiscovery = new Subject<any>();
  public calculateProgressEvent$ = this.changesInDiscovery.asObservable();

  /**
   * get user
   * @return user
   */
  getUser(showLoader = true) {
    return this.httpService.get<any>(`api/user`, null, showLoader ? loaderTypes.mainAnimation : loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getOtherUser(params) {
    return this.httpService.get<any>(`api/user`, { params: params }).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getPlaidLinkToken() {
    return this.httpService.get<any>(`api/user/plaid-link-token-create`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  exchangePlaidPublicToken(body) {
    return this.httpService.post<any>(`api/user/plaid-exchange-token`, body).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUpdatedData(data) {
    return this.httpService.post<any>(`api/user/update-mxMemberAccount`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createUserMemberAccountSingle(data) {
    return this.httpService.post<any>(`api/user/create-mxMemberAccountSingle`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createUserMemberLinking(data) {
    return this.httpService.post<any>(`api/user/create-mxMemberLinking`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  checkUserIsPremium(premium_status): any {
    if (premium_status == 'subscribed' || premium_status == 'cancelAtPeriodEnd' || premium_status == 'subscribedByProfessional') {
      return true;
    } else {
      return false;
    }
  }

  updateUserRemoveViewOnlyLicense(request) {
    return this.httpService.patch<any>(`api/user/remove-view-only-license`, request, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateUser(request) {
    return this.httpService.patch<any>(`api/user`, request, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateUserLinkedForm(request) {
    return this.httpService.patch<any>(`api/user/user-account-link-form`, request, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createFormUnLinkedForm(request) {
    return this.httpService.post<any>(`api/user/create-mxMemberAccount`, request, loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getCarDetails(data) {
    return this.httpService.post<any>(`api/user/vehicle-valuation-by-rapid`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getCarDetailsByLicencePlate(data) {
    return this.httpService.post<any>(`api/user/vehicle-valuation-by-usa-license`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getPropertyDetails(data) {
    return this.httpService.post<any>(`api/user/property-valuation-by-Zillow-rapid`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  deleteProfileRelation(request) {
    return this.httpService.post<any>(`api/user/profile-rel`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  inviteUserByEmail(request) {
    return this.httpService.post<any>(`api/user/invite-user`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserByEmail(request) {
    return this.httpService.post<any>(`api/user/get-byEmail`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateSummaryStatusData(data) {
    return this.httpService.post<any>(`api/user/setup-group-complete`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getSummaryStatusData(id) {
    return this.httpService.get<any>(`api/user/setup-group-summary/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserProfileStrength() {
    return this.httpService.get<any>(`api/user/account-strength`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserLocationList() {
    return this.httpService.get<any>(`api/user/user-location-path`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getDirectDeliveryConnection() {
    return this.httpService.get<any>(`api/user/direct-delivery-list-to-login-user`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getVaultUserLocationLinked() {
    return this.httpService.get<any>(`api/vault/vault-user-location-linked`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  postUserMailingAddress(request) {
    return this.httpService.post<any>(`api/user/mail-address/`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateUserMailingAddress(request) {
    return this.httpService.patch<any>(`api/user/mail-address/`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getUserMailingAddress(id) {
    return this.httpService.get<any>(`api/user/mail-address/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  searchEducationInstitutes(request) {
    return this.httpService.get<any>(`api/common/education-institutes/${request}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getAllCountries(country?: string, state?: string) {
    return fetch('https://www.universal-tutorial.com/api/getaccesstoken', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'api-token': 'jxbLhAnT984sG-H2nRcrIgKjxdXyhBzVozk0q7h4abQdMe7bzazV5loZgM4mdsTGUqs',
        'user-email': 'skender@kinnect.us',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (country) {
          return fetch(`https://www.universal-tutorial.com/api/states/${country}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${data.auth_token}`,
              Accept: 'application/json',
            },
          }).then((response) => response.json());
        }

        if (state) {
          return fetch(`https://www.universal-tutorial.com/api/cities/${state}`, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${data.auth_token}`,
              Accept: 'application/json',
            },
          }).then((response) => response.json());
        }

        return fetch('https://www.universal-tutorial.com/api/countries/', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${data.auth_token}`,
            Accept: 'application/json',
          },
        }).then((countries) => countries.json());
      });
  }

  createUserWork(request) {
    return this.httpService.post<any>(`api/user/work`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateUserWork(request) {
    return this.httpService.patch<any>(`api/user/work`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserWork(userId, workId) {
    return this.httpService.get<any>(`api/user/work/${userId}${workId}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getWorkHistory(userId) {
    return this.httpService.get<any>(`api/user/work/${userId}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteUserWork(request) {
    return this.httpService.delete<any>(`api/user/work`, request).pipe(
      map((response) => {
        return response;
      })
    );
  }

  createUserEducation(request) {
    return this.httpService.post<any>(`api/user/school`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateUserEducation(request) {
    return this.httpService.patch<any>(`api/user/school`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserEducation(userId, educationId) {
    return this.httpService.get<any>(`api/user/school/${userId}${educationId}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getEducationHistory(userId) {
    return this.httpService.get<any>(`api/user/school/${userId}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteUserEducation(request) {
    return this.httpService.delete<any>(`api/user/school`, request).pipe(
      map((response) => {
        return response;
      })
    );
  }

  createUserLocation(request) {
    return this.httpService.post<any>(`api/user/location`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateUserLocation(request) {
    return this.httpService.patch<any>(`api/user/location`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserLocation(userId, educationId) {
    return this.httpService.get<any>(`api/user/location/${userId}${educationId}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getLocationHistory(userId) {
    return this.httpService.get<any>(`api/user/location/${userId}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteUserLocation(request) {
    return this.httpService.delete<any>(`api/user/location`, request).pipe(
      map((response) => {
        return response;
      })
    );
  }

  selectAdminAccess(admin) {
    this.adminSelected.next(admin);
  }

  getAdmin() {
    return this.adminSelected.asObservable();
  }

  emitCalculatedProgressEvent(data: any) {
    this.changesInDiscovery.next(data);
  }
  // getUsernudge(userId) {
  //   return this.httpService.get<any>(`api/nudge/my-nudge/${userId}`, loaderTypes.none).pipe(
  //     map((response) => {
  //       if (response.status == 200) {
  //         return response.data;
  //       } else {
  //         return response;
  //       }
  //     })
  //   );
  // }

  registerUser(userData) {
    return this.httpService.post<any>(`api/user/register-user`, userData).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  viewTutorialClicked(request) {
    return this.httpService.post<any>(`api/tutorial/video`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getFolderTutorial(id) {
    return this.httpService.get<any>(`api/tutorial/video/${id}`, loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  setShareDone(done) {
    this.shareDone.next(done);
  }

  isShareDone() {
    return this.shareDone.asObservable();
  }

  getIfUserHasDistribution() {
    return this.httpService.get<any>(`api/user/check-user-has-distributor`, loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  // STANDARD USER LICENSE
  getStandardUserLicense() {
    return this.httpService.get<any>(`api/user/license`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createStandardUserLicense(request) {
    return this.httpService.post<any>(`api/user/license`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteStandardUserLicense(userId) {
    return this.httpService.delete<any>(`api/user/license/${userId}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          response;
        }
      })
    );
  }

  // PROFESSIONAL USER LICENSE

  getProfessionalUserLicense() {
    return this.httpService.get<any>(`api/user/license-professional`, loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createProfessionalUserLicense(request) {
    return this.httpService.post<any>(`api/user/license-professional`, request, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteProfessionalUserLicense(userId) {
    return this.httpService.delete<any>(`api/user/license-professional/${userId}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          response;
        }
      })
    );
  }

  getUserPublicKey(userId) {
    return of([]);
    // return this.httpService.get<any>(`api/user/get-user-publickey/${userId}`, null, loaderTypes.mainAnimation).pipe(
    //   map((response) => {
    //     if (response.status == 200) {
    //       return response.data;
    //     } else {
    //       return response;
    //     }
    //   })
    // );
  }

  getAutomatedReminderSettings() {
    return this.httpService.get<any>(`api/vault/vault-user-reminder-setting`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getAutomatedReminderSettingsTriggerActions() {
    return this.httpService.get<any>(`api/common/reminder-trigger-actions`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updatedAutomatedReminderSettings(payload) {
    return this.httpService.patch<any>(`api/vault/vault-user-reminder-setting`, payload).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  makeUserGuardian(payload) {
    return this.httpService.post<any>(`api/user/my-guardians`, payload, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  addGuardianUser(payload) {
    return this.httpService.post<any>(`api/user/guardian-user`, payload, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  addMultipleGuardianUsers({ guardianUsers, guardian_user_id }: { guardianUsers: Array<any>; guardian_user_id: number }) {
    return this.httpService.post<any>(`api/user/guardian-users`, { guardianUsers, guardian_user_id }, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getGuardianUsers(userId?: string) {
    const url = userId ? `api/user/guardian-user/${userId}` : `api/user/guardian-user`;
    return this.httpService.get<any>(url, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getMyGuardians() {
    return this.httpService.get<any>(`api/user/my-guardians`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  deleteMyGuardian(id: number) {
    return this.httpService.delete<any>(`api/user/my-guardians/${id}`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }
  addGuardianAdminUser(payload) {
    return this.httpService.post<any>(`api/user/guardian-user-admin`, payload, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getGuardianAdminUsers() {
    return this.httpService.get<any>(`api/user/guardian-user-admin`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  deleteGuardianAdminUsers(id: number) {
    return this.httpService.delete<any>(`api/user/guardian-user-admin/${id}`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }
  updateGuardianUser(payload) {
    return this.httpService.patch<any>(`api/user/guardian-user`, payload, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  deleteGuardianUser(payload) {
    return this.httpService.delete<any>(`api/user/guardian-user/${payload}`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  deleteInvite(payload) {
    return this.httpService.post<any>(`api/user/guardian-user-transfer-ownership-remove`, payload, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getGuardianUserDetails(id) {
    return this.httpService.get<any>(`api/user/guardian-user-details/${id}`, null, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  transferGuardianOwnership(payload) {
    return this.httpService.post<any>(`api/user/guardian-user-transfer-ownership`, payload, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  contactAdminCenter(payload) {
    return this.httpService.post<any>(`api/user/contact`, payload).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getLocations(id, vaultId?: any) {
    const route = vaultId ? `api/vault/vault-user-location/${id}?vault_id=${vaultId}` : `api/vault/vault-user-location/${id}`;
    return this.httpService.get<any>(route).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.files;
        } else {
          return response;
        }
      })
    );
  }
  getSubLocation(id, id2, vaultId?: any) {
    const route = vaultId ? `api/vault/vault-user-location/${id}/${id2}?vault_id=${vaultId}` : `api/vault/vault-user-location/${id}/${id2}`;

    return this.httpService.get<any>(route).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.files;
        } else {
          return response;
        }
      })
    );
  }

  moveLocation(payload, showLoader = false) {
    return this.httpService.post<any>(`api/vault/vault-user-location-move`, payload, showLoader ? loaderTypes.mainAnimation : loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }

  getAllCategoriesBasedOnType(type): Observable<any> {
    let url = `api/user/income-expense-category/${type}`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  checkIfUserCanCreateIncomeExpenseCategory(currentFormId): Observable<any> {
    let url = `api/user/check-create-income-expense/${currentFormId}`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createIncomeExpenseCategory(type, request) {
    let url = `api/user/income-expense-${type}-user`;
    return this.httpService.post<any>(url, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getDiscoveryPathActionItems(): Observable<any> {
    let url = `api/user/discovery-path-action-items`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getSetupList(): Observable<any> {
    let url = `api/user/setup-list`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getSetupListDetails(id): Observable<any> {
    let url = `api/user/setup-details-action/${id}`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getCollectionList(): Observable<any> {
    let url = `api/user/collection-list`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getCollectionDetails(id): Observable<any> {
    let url = `api/user/collection-details/${id}`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getCollectionActionDetails(id): Observable<any> {
    let url = `api/user/collection-details-action/${id}`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getDownloadURLForOnboardingCheckList(type, pathId): Observable<any> {
    let url = `api/user/onboarding-checklist-download-url/${type}/${pathId}`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getOnboardingChecklist(type, pathId): Observable<any> {
    let url = `api/user/onboarding-checklist/${type}/${pathId}`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateOnboardingChecklist(payload): Observable<any> {
    let url = 'api/user/onboarding-checklist';
    return this.httpService.patch<any>(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  completeCollectionGroup(payload): Observable<any> {
    let url = `api/user/collection-group-complete`;
    return this.httpService.post<any>(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  CompleteSetupActionGroup(payload): Observable<any> {
    let url = `api/user/setup-action-group-complete`;
    return this.httpService.post<any>(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  sendCollectionLink(payload): Observable<any> {
    let url = `api/user/collection-link`;
    return this.httpService.post<any>(url, payload, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  async getCountriesData() {
    const url = environment.apiUrl + '/api/user/all-countries';
    const session = await fetchAuthSession();

    const idToken = session.tokens?.idToken?.toString();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${idToken}`,
    });
    return this.http.get<any>(url, { headers }).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  async getStatesByCountryCode(countrycode: string) {
    const url = environment.apiUrl + `/api/user/states-by-countrycode/${countrycode}`;
    const session = await fetchAuthSession();

    const idToken = session.tokens?.idToken?.toString();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${idToken}`,
    });
    return this.http.get<any>(url, { headers }).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  async getCountriesDataByCountryAndStateCode(countrycode: string, stateCode: string) {
    const url = environment.apiUrl + `/api/user/cities-by-countrycode-and-statecode/${countrycode}/${stateCode}`;
    const session = await fetchAuthSession();

    const idToken = session.tokens?.idToken?.toString();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${idToken}`,
    });
    return this.http.get<any>(url, { headers }).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getCryptoCurrencySymbols() {
    const url = `api/user/crypto-currency-symbols`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getMetalSymbols() {
    const url = `api/user/metal-symbols`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getForeignCurrencySymbols() {
    const url = `api/user/foreign-currency-symbols`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getTickerSymbols() {
    const url = `api/user/ticker-symbols`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getCryptoCurrencySymbolValue(symbol) {
    const url = `api/user/yahoo-finance-crypto-price/${symbol}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getMetalSymbolValue(requestedSymbols, requestedUnitOfWeight) {
    const url = `api/user/latest-metal-price/${requestedSymbols}/${requestedUnitOfWeight}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getForeignCurrencySymbolValue(currencyType) {
    const url = `api/user/convert-foreign-currency/${currencyType}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getTickerSymbolValue(symbol) {
    const url = `api/user/yahoo-finance-stock-price/${symbol}`;
    return this.httpService.get(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getMerchantList(payload: { searchtext: string }): Observable<any> {
    return this.httpService.post<any>(`api/user/merchant-list`, payload, loaderTypes.none).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  createKinnectMerchant(payload): Observable<any> {
    return this.httpService.post<any>(`api/user/merchant`, payload, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateSecurityAndPrivacy(data: { security_and_privacy_complete: boolean }) {
    return this.httpService.patch<any>(`api/user/privacy-security-setup`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserLicenseStatus(userIds) {
    return this.httpService.post<any>(`api/user/user-license-status`, { userIds }).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  loadGoogleMapsApi(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (typeof (window as any).google !== 'undefined') {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key= ${environment.googleMapsApiKey}&libraries=places`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        resolve();
      };
      script.onerror = (error) => {
        reject('account:Google Maps API could not be loaded.');
      };
      document.head.appendChild(script);
    });
  }

  async trackEventsInMixPanel(events: { eventName: EventNames; data?: any }[]) {
    return await new Promise(async (resolve, reject) => {
      if (typeof Worker !== 'undefined') {
        let data = {
          token: '',
          url: '',
          events: [],
        };
        this.trackEventworker = new Worker(new URL('../../../shared/services/mix-pannel/event-tracker.worker', import.meta.url), {
          type: 'classic',
        });
        const session = await fetchAuthSession();

        const idToken = session.tokens?.idToken?.toString();
        const token = `Bearer ${idToken}`;
        data.token = token;
        data.url = `${environment.apiUrl}/api/user/track-event-in-mixpanel`;
        data.events = events;
        this.trackEventworker.onmessage = ({ data }) => {
          resolve(data);
        };
        this.trackEventworker.postMessage(data);
      } else {
        throw new Error('Method not implemented.');
      }
    });
  }

  cleanupWorker() {
    if (this.trackEventworker) {
      this.trackEventworker.terminate();
      this.trackEventworker = undefined;
    }
  }

  sendChangePasswordEmail(request) {
    return this.httpService.post<any>(`api/user/send-change-password-email`, request).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateCompleteIntroToKinnect(data: { intro_complete: boolean; user_id: string }) {
    return this.httpService.post<any>(`api/user/complete-intro-to-kinnect`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getCompleteIntroToKinnectValue() {
    return this.httpService.get<any>(`api/user/complete-intro-to-kinnect`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updateCompleteOnboardingResponsibility(data: { onboarding_responsibility_complete: boolean; user_id: string }) {
    return this.httpService.post<any>(`api/user/complete-onboarding-responsibility`, data).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getCompleteOnboardingResponsibilityValue() {
    return this.httpService.get<any>(`api/user/complete-onboarding-responsibility`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getSystemDrivenEmailRecipients(emailType) {
    const url = emailType ? `api/user/system-driven-email-recipients/${emailType}` : `api/user/system-driven-email-recipients`;
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  addSystemDrivenEmailRecipients(request) {
    const url = `api/user/system-driven-email-recipients`;
    return this.httpService.post(url, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteSystemDrivenEmailRecipients(recipientId, emailType) {
    const url = emailType
      ? `api/user/system-driven-email-recipients/${recipientId}/${emailType}`
      : `api/user/system-driven-email-recipients/${recipientId}`;
    return this.httpService.delete(url).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserTags() {
    const url = 'api/user/user-tags';
    return this.httpService.get(url, null, loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  addUserTags(request, loaderType = loaderTypes.mainAnimation) {
    const url = `api/user/user-tags`;
    return this.httpService.post(url, request, loaderType).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteUserTags(tagId) {
    const url = `api/user/user-tags/${tagId}`;
    return this.httpService.delete(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getUserTagsRegistered(showLoader = false) {
    const url = `api/user/user-tag-register`;
    return this.httpService.get(url, null, showLoader ? loaderTypes.mainAnimation : loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  logoutFromGuardianMode() {
    const url = `api/user/logout`;
    return this.httpService.post(url, {}).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  updateTrialLicenseForViewOnly(payload) {
    return this.httpService.post<any>(`api/user/trial-license-for-view-only`, payload, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  updatemxMemberAccountStatus(payload) {
    return this.httpService.patch<any>(`api/user/update-mxMemberAccountStatus`, payload, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getUserInfo(id: string) {
    return this.httpService.get<any>(`api/user/user-info/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getFamilyUserWidgetList() {
    return this.httpService.get<any>('api/user/user-widget-list', null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getActivityList() {
    this.httpService.hideLoader();
    return this.httpService.get<any>('api/user/user-activity', null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  // updateActivity(data) {
  //   return this.httpService.patch<any>(`api/user/user-activity`, data, loaderTypes.mainAnimation).pipe(
  //     map((response) => {
  //       if (response.status === 200) {
  //         return response.data;
  //       } else {
  //         return response;
  //       }
  //     })
  //   );
  // }
  getDataStorageUsage() {
    return this.httpService.get<any>(`api/user/user-license-data-usage`, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getAICreditsUsage(period?: string) {
    const url = period ? `api/user/user-license-token-usage/${period}` : `api/user/user-license-token-usage`;
    return this.httpService.get<any>(url, loaderTypes.mainAnimation).pipe(
      map((response) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
}
